import React from "react";

export default function ({ column: { filterValue, setFilter, preFilteredRows, id } }) {
  let options = new Set();
  const rows = [];

  preFilteredRows.forEach(row => {
    rows.push(row);
  });

  rows.sort((a, b) => a.values[id].localeCompare(b.values[id])).forEach(row => {
    options.add(row.values[id]);
  });

  options = [...options.values()];

  return (
    <select
      value={filterValue}
      onChange={e => {
        setFilter(e.target.value || undefined);
      }}
    >
      <option value="" />
      {options.map((option, i) => (
        <option key={i} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
}
